var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#916ede",
    opacity: 1,
    "data-original": "#afcffd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8159d9",
    d: "m340.284 100.914-.435.435-34.485 34.485-.435.435 82.211 82.211-14.886 14.886L229.828 90.941l-14.093 14.093-5.906 5.906 39.203 39.203-3.033 3.033 26.587 26.587-20.217 20.217-63.007-63.007-14.079-.845-13.277-13.277-14.093 14.093 98.591 98.591-125.136 125.138 61.814 61.814-8.691 8.691 80.813 80.813c.233.001.463.009.696.009 135.972 0 247.164-106.012 255.481-239.889z",
    opacity: 1,
    "data-original": "#8fbbfc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555a65",
    d: "M245.999 133.177v20h10l4.53-10-4.53-10z",
    opacity: 1,
    "data-original": "#555a65",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333940",
    d: "M255.999 133.177h10v20h-10z",
    opacity: 1,
    "data-original": "#333940",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555a65",
    d: "M209.829 90.941h20v20h-20z",
    opacity: 1,
    "data-original": "#555a65",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333940",
    d: "M356.652 145.552h20v20h-20zM309.711 189.463h20v20h-20z",
    opacity: 1,
    "data-original": "#333940",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.362,
    cy: 202.205,
    r: 38.731,
    fill: "#fb735d",
    opacity: 1,
    "data-original": "#fb735d",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.637,
    cy: 118.623,
    r: 25,
    fill: "#ee4a41",
    opacity: 1,
    "data-original": "#ee4a41",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ada63",
    d: "m255.999 278.724 14.906-52.369-14.906-57.803c-26.376 0-49.134 15.463-59.723 37.814a65.786 65.786 0 0 0-28.055-6.25c-36.483 0-66.058 29.575-66.058 66.058 0 4.293.424 8.485 1.206 12.549h152.63z",
    opacity: 1,
    "data-original": "#9ada63",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6abf48",
    d: "M408.631 278.724a66.34 66.34 0 0 0 1.206-12.549c0-36.483-29.575-66.058-66.058-66.058a65.79 65.79 0 0 0-28.056 6.25c-10.589-22.352-33.347-37.815-59.723-37.815v110.172z",
    opacity: 1,
    "data-original": "#6abf48",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcbf50",
    d: "M147.941 136.973c11.438 11.438 29.983 11.438 41.421 0l-41.421-41.421c-11.438 11.438-11.438 29.983 0 41.421z",
    opacity: 1,
    "data-original": "#fcbf50",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f5f9",
    d: "M256 414.141c-98.615 0-178.559-69.771-178.559-155.838H256l14.078 77.919z",
    opacity: 1,
    "data-original": "#f3f5f9",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.872,
    cy: 256,
    r: 22.5,
    fill: "#fcbf50",
    opacity: 1,
    "data-original": "#fcbf50",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e6ef",
    d: "M434.559 258.303c0 86.067-79.944 155.838-178.559 155.838V258.303z",
    opacity: 1,
    "data-original": "#e1e6ef",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e6ef",
    d: "M174.491 431.177v-34.274H256l7.968 17.137L256 431.177z",
    opacity: 1,
    "data-original": "#e1e6ef",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd7e5",
    d: "M256 396.903h81.711v34.274H256z",
    opacity: 1,
    "data-original": "#cfd7e5",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiet);
export default __webpack_public_path__ + "static/media/diet.b1ceb20a5dd08982f36dbc5dd44a1e3a.svg";
export { ForwardRef as ReactComponent };